import { TextFieldProps } from '@mui/material';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { Mask } from 'react-text-mask/index';
import MaskedField from '../FormInputs/MaskedField';

interface RHFMaskFieldProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  mask: Mask | ((value: string) => Mask);
  textFieldProps?: TextFieldProps;
  testId?: string;
  onValueChange?: (value: string) => void;
}

const RHFMaskField = <T extends FieldValues>({
  name,
  control,
  mask,
  textFieldProps,
  testId,
  onValueChange,
}: RHFMaskFieldProps<T>) => (
  <Controller
    name={name}
    control={control}
    render={({ field, fieldState }) => (
      <MaskedField
        mask={mask}
        {...textFieldProps}
        {...field}
        value={field.value ?? ''}
        error={!!fieldState.error}
        helperText={fieldState.error?.message ?? textFieldProps?.helperText}
        slotProps={{
          ...textFieldProps?.slotProps,
          htmlInput: {
            ...textFieldProps?.slotProps?.htmlInput,
            'test-id': testId,
          },
        }}
        onChange={(event) => {
          field.onChange(event);
          onValueChange?.(event.target.value);
        }}
      />
    )}
  />
);

export default RHFMaskField;
